var _defs, _use, _use2, _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _g, _g2, _path5, _path6, _g3, _g4, _g5, _path7, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPopupDeclineAllLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 204,
    viewBox: "0 0 312 204",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-8.7%",
    y: "-13.2%",
    width: "117.3%",
    height: "126.5%",
    filterUnits: "objectBoundingBox",
    id: "popup-decline-all-light_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.06 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.12 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-10.3%",
    y: "-66.7%",
    width: "120.5%",
    height: "252.4%",
    filterUnits: "objectBoundingBox",
    id: "popup-decline-all-light_svg__d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-19.3%",
    y: "-17.9%",
    width: "138.6%",
    height: "141%",
    filterUnits: "objectBoundingBox",
    id: "popup-decline-all-light_svg__f"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "popup-decline-all-light_svg__b",
    x: 0,
    y: 0,
    width: 312,
    height: 204,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "popup-decline-all-light_svg__g",
    x: 0,
    y: 0,
    width: 166,
    height: 156,
    rx: 4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "popup-decline-all-light_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAEFFE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAEFFE",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h312v38a4 4 0 01-4 4H4a4 4 0 01-4-4V0z",
    id: "popup-decline-all-light_svg__e"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#popup-decline-all-light_svg__a)",
    xlinkHref: "#popup-decline-all-light_svg__b"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    fill: "#FFF",
    xlinkHref: "#popup-decline-all-light_svg__b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#DAEFFE",
    width: 312,
    height: 204,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0h304a4 4 0 014 4v8H0V4a4 4 0 014-4z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DFE5EB",
    d: "M.5 11.5h311v1H.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B6C1CD",
    x: 4,
    y: 4,
    width: 4,
    height: 4,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B6C1CD",
    x: 11,
    y: 4,
    width: 4,
    height: 4,
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B6C1CD",
    x: 18,
    y: 4,
    width: 4,
    height: 4,
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1E4FE",
    d: "M16 105h58v58H16zM90 131h58v32H90zM90 35h58v80H90zM164 105h58v58h-58zM238 124h58v39h-58zM238 35h58v73h-58zM164 35h58v54h-58zM16 35h58v54H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#popup-decline-all-light_svg__c)",
    d: "M10 35h292v128H10z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 162)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#popup-decline-all-light_svg__d)",
    xlinkHref: "#popup-decline-all-light_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#popup-decline-all-light_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M241 174h40v18h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    fill: "#FFF",
    d: "M247 181h28v4h-28z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fill: "#7A92A5",
    d: "M155 181h28v4h-28zM201 181h28v4h-28z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M195.5 174.5h39v17h-39z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#162D3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.502 183.444l-2.169-2.168a.667.667 0 01.943-.943l2.168 2.169 2.169-2.169a.667.667 0 01.943.943l-2.169 2.168 2.169 2.169a.667.667 0 01-.943.943l-2.169-2.169-2.168 2.169a.667.667 0 01-.943-.943l2.169-2.169z"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fill: "#7A92A5",
    d: "M12 174h114v6H12zM12 186h76v6H12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 12h312v188a4 4 0 01-4 4H4a4 4 0 01-4-4V12z",
    fillOpacity: 0.66,
    fill: "#162D3D",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73 30)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#popup-decline-all-light_svg__f)",
    xlinkHref: "#popup-decline-all-light_svg__g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#popup-decline-all-light_svg__g"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M191 156h36v18h-36z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    fill: "#FFF",
    d: "M197 163h24v4h-24z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(207 122)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DFE5EB",
    width: 20,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 2,
    y: 2,
    width: 6,
    height: 6,
    rx: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(207 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DFE5EB",
    width: 20,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 2,
    y: 2,
    width: 6,
    height: 6,
    rx: 3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(207 78)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DFE5EB",
    width: 20,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 2,
    y: 2,
    width: 6,
    height: 6,
    rx: 3
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fill: "#7A92A5",
    d: "M85 80h98v6H85zM85 48h80v12H85zM85 124h86v6H85zM85 102h62v6H85z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#162D3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.502 38.444l-2.169-2.168a.667.667 0 01.943-.943l2.168 2.169 2.169-2.169a.667.667 0 01.943.943l-2.169 2.168 2.169 2.169a.667.667 0 01-.943.943l-2.169-2.169-2.168 2.169a.667.667 0 01-.943-.943l2.169-2.169z"
  }))))));
}

export default __webpack_public_path__ + "media/popup-decline-all-light.9ee0b1f5.svg";
export { SvgPopupDeclineAllLight as ReactComponent };